var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / PK") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-PK",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,0 L28,20 L8,20 L8,0 L28,0 Z",
    id: "Combined-Shape",
    fill: "#0A632F",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Star-8-+-Oval-3",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.471405, 9.764298) rotate(-45.000000) translate(-18.471405, -9.764298) translate(11.971405, 3.264298)",
    id: "Star-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4786562,10.8734084 C8.50356986,11.6670032 7.27691672,12.1398166 5.94441685,12.1398166 C2.76828243,12.1398166 0.193516749,9.45352508 0.193516749,6.13981658 C0.193516749,2.82610809 2.76828243,0.139816585 5.94441685,0.139816585 C7.27691672,0.139816585 8.50356986,0.612629944 9.4786562,1.40622474 C9.03593812,1.29182817 8.56970558,1.23072568 8.08827442,1.23072568 C5.20087949,1.23072568 2.86018342,3.42860054 2.86018342,6.13981658 C2.86018342,8.85103263 5.20087949,11.0489075 8.08827442,11.0489075 C8.56970558,11.0489075 9.03593812,10.987805 9.4786562,10.8734084 L9.4786562,10.8734084 Z M9.52685008,7.17981663 L7.95942274,8.29719524 L8.53775127,6.46119427 L6.99069937,5.31577127 L8.9155534,5.29843888 L9.52685008,3.47314992 L10.1381468,5.29843888 L12.0630008,5.31577127 L10.5159489,6.46119427 L11.0942774,8.29719524 L9.52685008,7.17981663 L9.52685008,7.17981663 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPk);
export default __webpack_public_path__ + "static/media/PK.35164e58d31544e9990745a6c55f6f93.svg";
export { ForwardRef as ReactComponent };